define([
    "./clientViewConfigurationModule",
    "./clientViewConfigurationRouter",
    "./clientViewConfigurationService",
    "./clientViewConfigurationController"
], function () {
});